import {
  styled,
  Typography,
  IconButton,
  MenuItem,
  MenuItemProps,
} from '@mui/material';

export const NameStyled = styled(Typography)(({ theme }) => ({
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
}));

export const ButtonMoreStyled = styled(IconButton)(({ theme }) => ({
  background: theme.palette.dark.dark_4,
  opacity: '0.5',
  ':hover': {
    background: theme.palette.primary.main,
  },
}));

interface MenuItemStyledProps extends MenuItemProps {
  red: boolean;
  green: boolean;
}
export const MenuItemStyled = styled(MenuItem)<MenuItemStyledProps>(
  ({ theme, red, green }) => ({
    color: red
      ? theme.palette.error.main
      : green
      ? theme.palette.success.main
      : 'inherit',
    '&:not(:last-child)': {
      borderBottom: '1px solid',
      borderColor: theme.palette.dark.dark_5,
    },
  }),
);
